/*

? First, let's import all types we will use to describe our interface.

*/

import StateInterface from "../state-interface";

/*

& Finally, let's describe and export our interface.

*/
export const rewards: StateInterface["rewards"] = {
	_id: 0,
	title: "",
	description: "",
	reward_type: "",
	reward_points: 0,
	steps_completed: 0,
	total_steps: 0,
	reset_on: new Date(),
	action: "",
};
